import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule,} from '@angular/common/http';
import {JwtHelperService} from '@auth0/angular-jwt';
import localePt from '@angular/common/locales/pt';
import {registerLocaleData} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {PagesModule} from './pages/pages.module';
import {LanguageService} from './services/language.service';
import {StorageServiceModule} from 'angular-webstorage-service';
import {ComponentsModule} from './components/components.module';
import {NgxLoadingModule} from 'ngx-loading';
import {AuthInterceptor} from './core/interceptor/auth.interceptor';
import {ToastrModule} from 'ngx-toastr';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DirectiveModule} from './directives/directive.module';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TagInputModule} from 'ngx-chips';
import {environment} from '../environments/environment';
import {FBAccountService} from './services/utils/fb-account.service';

registerLocaleData(localePt);

// token de autenticação
const TOKEN_KEY = 'omni-token';

export function tokenGetter() {
    return localStorage.getItem(TOKEN_KEY);
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
}

export function appInitializer(accountService: FBAccountService) {
    return () => new Promise(resolve => {
        window['fbAsyncInit'] = function () {
            FB.init({
                appId: environment.facebookAppId,
                cookie: true,
                xfbml: true,
                version: 'v15.0'
            });

            FB.getLoginStatus(({authResponse}) => {
                resolve(authResponse);
            });
        };

        // load facebook sdk script
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    });
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        PagesModule,
        ComponentsModule,
        StorageServiceModule,
        AppRoutingModule,
        HttpClientModule,
        NgxLoadingModule.forRoot({
            fullScreenBackdrop: true,
        }),
        ToastrModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        NgbModule,
        DirectiveModule,
        TagInputModule
    ],
    providers: [
        JwtHelperService,
        LanguageService,
        {provide: LOCALE_ID, useValue: 'pt-br'},
        BsDatepickerModule.forRoot().providers,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
            deps: [FBAccountService]
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
